import { useAuth } from '@/contexts/AuthContext';
import { priceFormatterV2 } from '@/lib/utils';
import { Audience } from '@/services/AudiencesService';

interface ARPUProps {
  audience: Pick<Audience, 'average_revenue_per_user'>;
}

export function ARPU({ audience }: ARPUProps) {
  const { user } = useAuth();

  return (
    <div className="hidden flex-row justify-between gap-2">
      <p className="text-sm text-gray-600">ARPU</p>
      <div className="text-w-10 flex flex-row items-center gap-2 font-semibold">
        {priceFormatterV2(
          Number(audience.average_revenue_per_user),
          user!.customer.language,
          user!.customer.platform,
        )}
      </div>
    </div>
  );
}
